/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global console, document, Excel, Office, $, window */

Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    loadSheets();
    initializeSheetChangeHandler();
    document.getElementById("saveSheetMeta").onclick = saveSheetMeta;
  }
});

let selectedSheet = null;

function loadSheets() {
  console.log("loadSheets ")
  Excel.run(function (context) {
    const sheets = context.workbook.worksheets;
    sheets.load("items/name, position");

    return context.sync().then(function () {
      const data = [];
      const metaPromises = sheets.items.map((sheet, index) => {
        console.log(sheet.name)
        console.log(sheet.position)
        return getSheetMeta(sheet.name).then((meta) => {
          if (meta) {
            let obj = JSON.parse(meta)
            obj.title = sheet.name
            data.push(obj);
          } else {
            const obj = {
              id: sheet.id,
              parent_id: 0,
              title: sheet.name,
              level: 1,
              position: sheet.position,
            };
            data.push(obj);
            return setSheetMeta(sheet.name, JSON.stringify(obj));
          }
        });
      });
      console.log(data)
      // Wait for all metadata-related operations to complete
      return Promise.all(metaPromises).then(() => {
        // Sort the data array by position in ascending order
        data.sort((a, b) => a.position - b.position);

        const TreeId = "#tree";
        const Sortable = new TreeSortable({
          treeSelector: TreeId,
        });
        const $Tree = $(TreeId);
        const $content = data.map(Sortable.createBranch);

        //console.log("content");
        //console.log($content);
        $Tree.html($content);

        Sortable.run();


        const delay = () => {
          return new Promise((resolve) => {
            console.log("delay")
            setTimeout(() => {
              console.log("resolve   ")
              resolve();
            }, 1000);
          });
        };
        $(document).off();
        Sortable.addListener("click", ".tree-branch", function (event) {
          /*console.log("click", " .tree-branch")
          console.log(event)
          console.log(event.target)
          console.log(typeof event.target)
          console.log(event.currentTarget)
          console.log(event.currentTarget.parentElement)*/
          event.preventDefault();
          if(event.target.classList.contains("fa-trash") || event.target.classList.contains("fa-square-plus") || event.target.classList.contains("fa-circle-plus")){
            return;
          }
          if(event.currentTarget.parentElement != null){
            activateSheet($(event.currentTarget).attr("data-id"));
            const allListItems = event.currentTarget.parentElement.querySelectorAll("li");
            allListItems.forEach((li) => li.classList.remove("active"));
            event.currentTarget.classList.add("active");
          }
        });

        Sortable.onSortCompleted(async (event, ui) => {
          console.log("onSortCompleted")
          await delay();
        });

        Sortable.addListener("click", ".add-child", function (event, instance) {
          console.log("click", " .add-child")
          event.preventDefault();
          instance.addChildBranch($(event.target));
        });

        Sortable.addListener("click", ".add-sibling", function (event, instance) {
          console.log("click", " .add-sibling")
          event.preventDefault();
          instance.addSiblingBranch($(event.target));
        });

        Sortable.addListener("click", ".remove-branch", function (event, instance) {
          console.log("click", " .remove-branch")
          event.preventDefault();
          //$(event.target).closest("li").off()
          //const confirm = window.confirm("Are you sure you want to delete this branch?");
          //if (!confirm) {
          // return;
          //}
          instance.removeBranch($(event.target));
        });

        Sortable.addListener("contextmenu", ".tree-branch", function (event, instance) {
          console.log("contextmenu", "  .tree-branch")
          event.preventDefault();
          selectSheet(event.target.innerText);
        });

        const activeSheet = context.workbook.worksheets.getActiveWorksheet();
        activeSheet.load(["name", "id"]);
        context.sync().then(() => {
          sheetActivateHandler(undefined, activeSheet.id)
        });
        

        tippy("[data-tippy-content]");

      });
    });
  }).catch(function (error) {
    console.error(error);
    const sheetsList = document.getElementById("sheetsList");
    sheetsList.innerHTML = `Error: ${error}`;
  });
}

export async function saveSheetMeta() {
  const metaValue = document.getElementById("metaInput").value;
  if (selectedSheet) {
    setSheetMeta(selectedSheet, metaValue);
  } else {
    //alert("Please select a sheet first.");
  }
}

function setSheetMeta(sheetName, metaValue) {
  Excel.run(function (context) {
    const sheet = context.workbook.worksheets.getItem(sheetName);
    sheet.customProperties.add("metadata", metaValue);
    return context.sync();
  }).catch(function (error) {
    console.error("Error setting sheet metadata:", error);
  });
}

function getSheetMeta(sheetName) {
  return Excel.run(function (context) {
    const sheet = context.workbook.worksheets.getItem(sheetName);
    const customProperty = sheet.customProperties.getItemOrNullObject("metadata");
    customProperty.load("value");

    return context.sync().then(function () {
      return customProperty.value || "";
    });
  }).catch(function (error) {
    console.error("Error getting sheet metadata:", error);
    return "";
  });
}

function selectSheet(sheetName) {
  selectedSheet = sheetName;
  document.getElementById("metaInput").value = ""; // Clear metadata input
  document.getElementById("sheetname").innerHTML = sheetName;
  getSheetMeta(sheetName).then((meta) => {
    if (meta) {
      document.getElementById("metaInput").value = meta;
    }
  });
}

function activateSheet(id) {
  console.log("activateSheet  ", id)
  Excel.run(function (context) {
    const sheet = context.workbook.worksheets.getItem(id);
    sheet.activate();
    return context.sync();
  }).catch(function (error) {
    console.error("Error activating sheet:", error);
  });
}

function initializeSheetChangeHandler() {
  Excel.run(function (context) {
    const workbook = context.workbook;
    workbook.worksheets.onAdded.add(sheetChangeHandler);
    workbook.worksheets.onDeleted.add(sheetChangeHandler);
    workbook.worksheets.onNameChanged.add(sheetRenameHandler)
    workbook.worksheets.onActivated.add(sheetActivateHandler)

    return context.sync();
  }).catch(function (error) {
    console.error("Error initializing sheet change handler:", error);
  });
}

function sheetChangeHandler(event) {
  loadSheets();
}

function sheetRenameHandler(event) {
  $("#tree > li").each(function(){
    if ($(this).find(".branch-title").text() == event.nameBefore) {
      $(this).find(".branch-title")[0].innerHTML = event.nameAfter
      getSheetMeta(event.nameAfter).then((meta) => {
        let obj = JSON.parse(meta)
        obj.title = event.nameAfter
        setSheetMeta(event.nameAfter, JSON.stringify(obj));
      });
    }
  })
}

function sheetActivateHandler(event, id) {
  console.log("sheetActivateHandler ")
  const allListItems = document.querySelectorAll("li");
  allListItems.forEach((li) => li.classList.remove("active"));
  if(typeof event != "undefined")
    document.querySelectorAll("[data-id='" + event.worksheetId + "']")[0].classList.add("active");
  else
    document.querySelectorAll("[data-id='" + id + "']")[0].classList.add("active");
}